import { DecoratorNode, SerializedLexicalNode, Spread } from 'lexical';

import MergeTagComponent from './MergeTagComponent';

export type MergeTagData = {
  name: string;
  description: string;
};

export type SerializedMergeTagNode = Spread<
  {
    type: 'merge-tag';
    version: 1;
    mergeTagData: MergeTagData;
  },
  SerializedLexicalNode
>;

// export class MergeTagNode extends TextNode {
export class MergeTagNode extends DecoratorNode<JSX.Element> {
  __mergeTag: MergeTagData;

  constructor(mergeTag: MergeTagData, key?: string) {
    super(key);
    this.__mergeTag = mergeTag;
  }

  static getType(): string {
    return 'merge-tag';
  }

  static clone(node: MergeTagNode): MergeTagNode {
    return new MergeTagNode({ ...node.__mergeTag }, node.__key);
  }

  decorate() {
    return <MergeTagComponent mergeTag={this.__mergeTag} />;
  }

  exportJSON(): SerializedMergeTagNode {
    return {
      ...super.exportJSON(),
      type: 'merge-tag',
      version: 1,
      mergeTagData: this.__mergeTag,
    };
  }

  static importJSON(serializedNode: SerializedMergeTagNode): MergeTagNode {
    return new MergeTagNode(serializedNode.mergeTagData);
  }

  // createDOM(): HTMLElement {
  //   const dom = super.createDOM(config);
  //   dom.classList.add('merge-tag'); // Only affects the editor

  //   if (this.__mergeTag.description) {
  //     dom.setAttribute('title', this.__mergeTag.description);
  //   }
  //   return dom;
  // }

  createDOM(): HTMLElement {
    return document.createElement('span');
  }
}
